import { Filter } from "lucide-react";
import React, { useContext, useState } from "react";
import Breadcrumbs from "~/components/Breadcrumbs";
import FiltersBar from "~/components/FiltersBar";
import PageHeader from "~/components/PageHeader";
import { getCurrentPage } from "~/functions";
import AbsenceControl from "./Reports/AbsenceControl";
import ClassSchedule from "./Reports/ClassSchedule";
import EvaluationChart from "./Reports/EvaluationChart";
import EnrollmentBarChart from "./Reports/EnrollmentBarChart";
import PeriodDropdown from "./Reports/PeriodDropdown";
import MapCount from "./Reports/MapCount";
import InactivationBarChart from "./Reports/InactivationBarChart";
import { useSelector } from "react-redux";
import { FullGridContext } from ".";

export default function AdministrativeDashboard() {
  const currentPage = getCurrentPage();
  const { profile } = useSelector((state) => state.auth);
  const isAdmin = profile.id === 1;

  const {
    accessModule,
    activeFilters,
    gridData,
    gridDetails,
    gridHeader,
    handleFilters,
    handleOpened,
    limit,
    loadingData,
    opened,
    orderBy,
    page,
    pages,
    search,
    setActiveFilters,
    setGridData,
    setGridDetails,
    setGridHeader,
    setLimit,
    setLoadingData,
    setOpened,
    setOrderBy,
    setPage,
    setPages,
    setSearch,
    setTotalRows,
    setSuccessfullyUpdated,
    successfullyUpdated,
    totalRows,
  } = useContext(FullGridContext);

  const pageAccess = accessModule.children.find(
    (el) => el.alias === "administrative-dashboard"
  );

  const hasAccessToAlias = (alias) => {
    return pageAccess?.children?.find((el) => el.alias === alias)
      ?.MenuHierarchyXGroup?.view;
  };

  const [periodChoice, setPeriodChoice] = useState(
    String(new Date().getFullYear())
  );
  const year = Number(periodChoice);

  return (
    <div className="h-full bg-white flex flex-1 flex-col justify-start items-start rounded-tr-2xl px-4 overflow-y-scroll">
      <PageHeader>
        <Breadcrumbs currentPage={currentPage} />
        <FiltersBar>
          <Filter size={14} /> Custom Filters
        </FiltersBar>
      </PageHeader>

      {hasAccessToAlias("students-in-class-chart") && (
        <>
          <PeriodDropdown value={periodChoice} onChange={setPeriodChoice} />
          <EnrollmentBarChart year={year} />
        </>
      )}
      {hasAccessToAlias("active-students-by-country-chart") && (
        <MapCount></MapCount>
      )}
      {hasAccessToAlias("acess_inactivations") && (
        <InactivationBarChart year={year} />
      )}
    </div>
  );
}
